import { Fragment } from 'react'
import { useTranslation } from 'next-i18next'

import ResponsiveImage from '~/components/Image/ResponsiveImage'
const mediaQuery = [{ screen: '(min-width: 280px)', width: '50px' }]
export default function QuizResultKudos({ kudosEarned }: { kudosEarned?: number }): React.ReactElement {
  const { t } = useTranslation('homebase')
  if (kudosEarned) {
    return (
      <div className="flex items-center text-lg px-6 mt-2">
        {[...Array(kudosEarned)].map((n, i) => (
          <ResponsiveImage
            alt={t('kudos')}
            height={50}
            imageClassName="px-1"
            imageWidths="50"
            key={`kudos${i.toString}`}
            mediaQuery={mediaQuery}
            srcKey="bootcamp/kudos-orb.png"
            width={50}
          />
        ))}
      </div>
    )
  }

  return <Fragment />
}
